import React from 'react'
import { LOGODatasetDishub } from 'src/assets/image'

function Kategori({ ...props }) {
    return (
        <div>
            <div className="widget widget-text">
                <h3 className="widget-title">Format</h3>
                <div className="ttm-author-widget">
                    <h6>{props.Name || 'Belum ada'}</h6>
                </div>
            </div>
        </div>
    )
}

export default Kategori
